import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationRegimeCreateRequest, ConfigurationRegimePatchInBatchRequest, ConfigurationRegimeResponse } from '@/api/resources/configuration/cases/regime/configuration-regime.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import axios from 'axios'

class ConfigurationRegimeService {
    async create(request: ConfigurationRegimeCreateRequest): Promise<ConfigurationRegimeResponse> {
        const response = await axios.post<ConfigurationRegimeResponse>(`/configuration/regimes`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationRegimeResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationRegimeResponse>>(`/configuration/regimes`, { ...filterModel }, { params })
        return response.data
    }

    async get(centerId: number): Promise<ConfigurationRegimeResponse> {
        const response = await axios.get<ConfigurationRegimeResponse>(`/configuration/regimes/${centerId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/regimes/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationRegimePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/regimes/batch`, request)
        return response.data
    }
}

export const configurationRegimeService = new ConfigurationRegimeService()
